import React from 'react';
import { useHistory } from 'react-router';

// components
import SubHeading from '../../../components/text/SubHeading/SubHeading.component';
import ActionButton from '../../../components/buttons/ActionButton/ActionButton.component';

// collections
import RequestsByStatus from './collections/RequestsByStatus/RequestsByStatus.collection';

// mui
import { Grid, Container, Typography } from '@mui/material';

export default function MyRequests() {
    const history = useHistory();

    return (<div>
        
        <Container maxWidth sx={{ marginBottom: 4}} disableGutters>
            <Grid container spacing={2} justifyContent='space-between' alignItems={'center'}>
                <Grid item xs={8}><Typography variant="h2">My Requests</Typography></Grid>
                <Grid item xs={4} textAlign='right'><ActionButton label="New Request" onClick={() => history.push('/requests/new')} /></Grid>
            </Grid>
        </Container>

        

        <Container disableGutters sx={{ marginBottom: 8 }}>
            <Grid container spacing={2}>
                <Grid item xs={4}><Typography variant="h5">Submitted</Typography></Grid>
                <Grid item container direction='column' xs={8}><RequestsByStatus status='S' /></Grid>
            </Grid>
        </Container>

        <Container disableGutters sx={{ marginBottom: 8 }}>
            <Grid container spacing={2}>
                <Grid item xs={4}><Typography variant="h5">Fulfilled</Typography></Grid>
                <Grid item container direction='column' xs={8}><RequestsByStatus status='H' /></Grid>
            </Grid>
        </Container>
        
        
        
    </div>)
}